import { captureException } from '@sentry/browser';
import { APIResponseError } from 'models/error';
import endpoint from 'shared/api';

import { StudentChecklistRequest } from '../models';
import { isStudentChecklistCompleted } from '../utils/isChecklistCompleted';

export const updateAndCompleteStudentChecklist = async (
  userPolicyId: string,
  updatedChecklist: Partial<StudentChecklistRequest>
) => {
  try {
    const updateChecklistResponse = await endpoint.updateStudentChecklist(
      userPolicyId,
      updatedChecklist
    );

    const completed = isStudentChecklistCompleted(updateChecklistResponse.data);

    if (completed) {
      await endpoint.completeStudentChecklist(userPolicyId);
    }
  } catch (err) {
    const error = err as APIResponseError;
    const errorMessage = error.response?.data?.message;
    captureException(
      `[STUDENT_CHECKLIST] Failed to update student checklist with policy id ${userPolicyId}: ${errorMessage}`
    );
    throw new Error(errorMessage);
  }
};
